
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { confirmSignUp } from '@/service/cognitoService';
import { AppStatus } from '@/model/status';

export default defineComponent({
  name: 'ConfirmSignUp',
  data () {
    return {
      signUpConfirmationSucced: false
    };
  },
  async mounted () {
    try {
      this.startLoading();
      await confirmSignUp(this.emailToConfirm, this.confirmationCode);
      this.setAppStatus(AppStatus.ConfirmSignUpSuccess);
    } catch (error) {
      this.setAppStatus(AppStatus.ConfirmSignUpError);
    } finally {
      this.endLoading();
      this.setMyEmail(this.emailToConfirm);
      this.pushLogin();
    }
  },
  methods: {
    ...mapActions(['setMyEmail', 'setAppStatus', 'startLoading', 'endLoading']),

    pushLogin () {
      this.$router.push({
        path: 'login',
        query: {
          client_id: this.$route.query.client_id,
          redirect_uri: this.$route.query.redirect_uri,
          language: this.$route.query.language
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      'emailToConfirm',
      'confirmationCode'
    ])
  }
});
